<style>

  .a-flex {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    flex-wrap: wrap;
  }
</style>

<template>
  <Row>
    <Col :span="span" class="a-flex">
      <div
        :style="{textAlign: textAlign, padding: '4px 2px', fontSize: '14px', width: labelWidth + 'px'}">
        <strong>{{ label }}：</strong></div>
      <div :style="{padding: '4px 2px', fontSize: '14px', width: contentWidth}">
        <slot/>
      </div>
    </Col>
  </Row>
</template>

<script>
export default {
  props: {
    label: String,
    labelWidth: {
      type: String,
      default: '100'
    },
    span: {
      type: Number,
      default: 24
    },
    textAlign: {
      type: String,
      default: 'right'
    }
  },
  computed: {
    contentWidth () {
      return 'calc(100% - ' + this.labelWidth + 'px)'
    }
  }
}
</script>
